import './ScopeDisplaySelector.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Radio } from 'antd';
import React from 'react';
import { DensityComfortableIcon, DensityCompactIcon } from '@ui/icons';
export const ScopeDisplaySelector = ({ onChange, value }) => React.createElement("div", { className: 'scope-display-selector' },
    React.createElement("span", null, COPY_SPECIFIC.VIEW),
    React.createElement(Radio.Group, { buttonStyle: 'solid', defaultValue: 'comfortable', onChange: (e) => onChange(e.target.value), options: [
            {
                label: React.createElement(DensityComfortableIcon, null),
                value: 'comfortable'
            },
            {
                label: React.createElement(DensityCompactIcon, null),
                value: 'compact'
            }
        ], optionType: 'button', value: value }));
